import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ParagraphSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ParagraphSVG;
